import React from 'react';
import { motion } from 'framer-motion';
import { Flame } from 'lucide-react';
import { trackAddToCart } from '../../lib/meta-pixel';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  fullWidth = false,
  onClick,
  ...props
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e);
    } else {
      trackAddToCart();
      window.open('https://guias-salud.com/cart/46122403594428:1', '_blank');
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`
        relative group overflow-hidden rounded-md font-heading font-bold text-xl md:text-2xl 
        text-white uppercase tracking-wide py-4 px-8 shadow-[0_0_20px_rgba(232,130,12,0.3)]
        transition-shadow duration-300 hover:shadow-[0_0_30px_rgba(245,158,11,0.5)]
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} {...props} data-id="element-172">
      <div className="absolute inset-0 bg-fire-gradient transition-transform duration-300 group-hover:scale-105" data-id="element-173" />
      <div className="absolute inset-0 bg-black/10 group-hover:bg-transparent transition-colors duration-300" data-id="element-174" />
      <span className="relative flex items-center justify-center gap-3" data-id="element-175">
        <Flame className="w-6 h-6 text-yellow-200 animate-pulse" data-id="element-176" />
        {children}
        <Flame className="w-6 h-6 text-yellow-200 animate-pulse" data-id="element-177" />
      </span>
    </motion.button>;
}